import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

const FILTER_RIGHT_POSITION = Platform.select({
    web: widthPercentageToDP(72),
    default: 16,
});

export const defaultModalStartingPosition = {
    right: FILTER_RIGHT_POSITION,
    bottom: Platform.select({ web: 88, ios: 132, default: 112 }),
};
export const PICKER_LIST_HEIGHT = widthPercentageToDP(352);
export const PICKER_LIST_WIDTH = 240;

const styles = StyleSheet.create({
    root: {
        position: 'absolute',
        bottom: Platform.select({
            web: 40,
            default: 16,
        }),
        right: FILTER_RIGHT_POSITION,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: COLOR.primary,
        width: 40,
        height: 40,
        borderRadius: 40,
    },
    pickerButtonContainer: {
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: COLOR.background,
        paddingHorizontal: isTabletOrWeb ? 8 : 4,
    },
    svgArrowContainer: {
        height: '100%',
        marginLeft: 4,
        justifyContent: 'center',
    },
});

export default styles;
